module.exports = __webpack_public_path__ + "img/course.094b9cdc.svg";